module.exports = "../../../../platform/assets/pageMainIcon/icon-renyuan-4-red.svg";